import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

import { Title } from 'components/typography';

import {
  productCard,
  productCardHeader,
  productIcon,
  productTitle,
  productDescription,
  productLink,
} from './scss/Products.module.scss';

const ProductCard = ({ title, icon, description, link }) => (
  <div className={productCard}>
    <div className={productCardHeader}>
      <span className={productIcon}>{icon}</span>
      <Title className={productTitle} value={title} />
    </div>
    <p className={productDescription}>{description}</p>
    <Link className={productLink} to={link}>
      LEARN MORE
    </Link>
  </div>
);

ProductCard.prottypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};

export default ProductCard;
